import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../../components/Loader'
import PreviousProductAdCard from '../../../components/PreviousProductAdCard'
import PreviousShelfAdCard from '../../../components/PreviousShelfAdCard'
import PreviousStoreAdCard from '../../../components/PreviousStoreAdCard'

const PreviousAds = () => {
    const [ads, setAds] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)

    const navigate = useNavigate()

    const { name } = useParams()

    useEffect(() => {
        const getAds = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/manage/promotions/previous`, { params: { page } })
                console.log(response)
                if (response) {
                    setIsLoading(false)
                    setAds(response.data.ads)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getAds()
    }, [name])

    console.log(ads)

    return (
        <div className='page-content'>
            <div className="">

                <InfiniteScroll
                    dataLength={() => ads.length}
                    next={false}
                    hasMore={false}
                >
                    <div className="ads-container">
                        {isLoading && <Loader />}
                        {!isLoading && ads.length === 0 && <p className="not-found-msg">No ads found</p>}
                        {
                            ads.length > 0 &&
                            ads.map((ad) => {
                                switch (ad.adType) {
                                    case "product":
                                        return <PreviousProductAdCard key={ad._id} ad={ad} />;
                                    case "shelf":
                                        return <PreviousShelfAdCard key={ad._id} ad={ad} />;

                                    case "store":
                                        return <PreviousStoreAdCard key={ad._id} ad={ad} />;

                                    default:
                                        return null;
                                }
                            })
                        }
                    </div>
                </InfiniteScroll>

            </div>
        </div>
    )
}

export default PreviousAds